import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from 'store';

import DesktopHotelsSearch from 'components/DesktopHotelsSearch';
import { GetAllBillingCompanyResponse } from 'models/billingCompany';
import { TravelArrangerUsersAllowed } from 'services/userService';

type Props = {
  allowedTravelers: TravelArrangerUsersAllowed[];
  isLoadingAllowedTravelers: boolean;
  isLoading?: boolean;
  branchCompanies?: GetAllBillingCompanyResponse[];
  isLoadingBranchCompanies: boolean;
};

const DesktopHotelsSearchContainer = ({
  allowedTravelers,
  isLoadingAllowedTravelers,
  isLoading,
  branchCompanies,
  isLoadingBranchCompanies,
}: Props) => {
  const { travelers, destinationPoint, checkInDate, checkOutDate, branchCompany } = useSelector(
    (state: RootState) => state.hotels,
  );

  return (
    <DesktopHotelsSearch
      defaultTravelers={travelers}
      defaultDestinationPoint={destinationPoint}
      defaultCheckInDate={checkInDate}
      defaultCheckOutDate={checkOutDate}
      allowedTravelers={allowedTravelers}
      isLoadingAllowedTravelers={isLoadingAllowedTravelers}
      isLoading={isLoading}
      branchCompanies={branchCompanies}
      isLoadingBranchCompanies={isLoadingBranchCompanies}
      defaultBranchCompany={branchCompany}
    />
  );
};

export default DesktopHotelsSearchContainer;
